const ERRCODE_400 = 400;
const ERRCODE_401 = 401;
const ERRCODE_403 = 403;
const ERRCODE_404 = 404;
const ERRCODE_408 = 408;
const ERRCODE_500 = 500;
const ERRCODE_UNKNOWN = 1000;
const ERRCODE_TIMEOUT = 1001;

export default {
    ERRCODE_400,
    ERRCODE_401,
    ERRCODE_403,
    ERRCODE_404,
    ERRCODE_408,
    ERRCODE_500,
    ERRCODE_UNKNOWN,
    ERRCODE_TIMEOUT,

}